{
  "table": {
    "client": "Client",
    "workflow": "Workflow",
    "section": "Section",
    "step": "Step",
    "state": "State",
    "started": "Started",
    "objectTypes": {
      "ACCOUNT": "Account",
      "ACCOUNT_GROUP": "Account Group",
      "GOAL": "Goal",
      "HOUSEHOLD": "Household",
      "SUB_ACCOUNT": "Sub-Account",
      "USER": "User"
    }
  },
  "title": "Title",
  "subtitle": "Subtitle",
  "state": "State",
  "icon": "Icon",
  "applied": "Applied",
  "source": "Source",
  "startWorkflow": "Start {{workflowName}}",
  "caughtUp": "You're all caught up",
  "caughtUpSubtitle": "This is now with another person in the flow. Please come back later.",
  "closeWorkflow": "Close workflow",
  "pasteWarning": "As a beta feature, pasting in workflow configurations may cause issues. Please use with caution and test first in a safe environment. Role profile restrictions are not supported and will be removed on upload.",
  "workflowUpdated": "Workflow updated",
  "workflowIssues": "Workflow updated, but has warnings",
  "roleProfileNotFound": "There was a role profile on the {{subStep}} step, in '{{step}}' that was not found in this organization, all role profile restrictions have been removed from the configuration in that step.",
  "goalWorkflowNotFound": "There was a goal workflow on the {{subStep}} step, in '{{step}}' that was not found in this organization, it has been removed from the configuration.",
  "customFieldNotFound": "The custom field '{{customField}}' on the {{subStep}} step, in '{{step}}' was not found in this organization, it has been removed from the configuration.",
  "skippable": "Skippable",
  "skip": "Skip",
  "editCode": "Edit Code",
  "copy": "Copy Workflow Configuration",
  "paste": "Paste Workflow Configuration",
  "continue": "Continue",
  "canGoBack": "Can go back",
  "addRoleProfileToWorkflow": "Add a role profile to a workflow",
  "completeableBy": "Roles can complete",
  "update": "Update",
  "remove": "Remove",
  "create": "Create",
  "add": "Add",
  "workflowName": "Workflow Name",
  "workflowState": "Workflow State",
  "workflowObjectType": "Object type",
  "workflowObjectTypes": {
    "USER": "User",
    "ACCOUNT": "Account",
    "GOAL": "Goal",
    "SUB_ACCOUNT": "Sub-account",
    "HOUSEHOLD": "Household",
    "ACCOUNT_GROUP": "Account group"
  },
  "trigger": "Trigger",
  "event": "Event",
  "createAnotherAccount": "Create another account",
  "createAnotherGoal": "Create another goal",
  "workflow": "Workflow",
  "section": "Section",
  "step": "Step",
  "triggerType": {
    "MANUAL": "Manual",
    "EVENT": "Event Based"
  },
  "schedule": {
    "ONE_TIME": "One-Time",
    "WEEKLY": "Weekly",
    "BI_WEEKLY": "Bi-Weekly",
    "SEMI_MONTHLY": "Semi-Monthly",
    "MONTHLY": "Monthly",
    "QUARTERLY": "Quarterly"
  },
  "eventType": {
    "CREATED": "Client Created",
    "PERSONAL_INFORMATION_UPDATED": "PII Updated",
    "SUITABILITY_SCORE_UPDATED": "Suitability Score Updated",
    "SUITABILITY_REVIEW_DUE": "KYC Review Required",
    "INTEGRATION_FORM_CREATED": "Form Generated Externally",
    "ENTITY_INVITED": "Client Invited",
    "ACCOUNT_AFFILIATE_UPDATED": "Account Affiliate Updated",
    "SCHEDULED_TRANSFER_UPDATED": "Scheduled Transfer Updated",
    "SCHEDULED_TRANSFER_CANCELED": "Scheduled Transfer Canceled"
  },
  "customAttributeLabels": {
    "disabledInfo": "Customization of these options is being set at an organization level. Please adjust these settings in the Custom Attribute Labels menu."
  },
  "saveWorkflow": "Save Workflow",
  "savedWorkflowMessage": "Workflow saved",
  "addStep": "Add Step",
  "addSection": "Add Section",
  "newSectionName": "New Section",
  "name": "Name",
  "description": "Description",
  "level": "Level",
  "eventTriggerRule": {
    "field": "Field",
    "comparison": "Comparison",
    "value": "Value",
    "addNewRule": "Add rule"
  },
  "investmentKnowledge": {
    "NONE": "None",
    "SOME": "Some",
    "LIMITED": "Limited",
    "EXPERT": "Expert"
  },
  "riskLevels": {
    "LEVEL_1": "Level 1",
    "LEVEL_2": "Level 2",
    "LEVEL_3": "Level 3",
    "LEVEL_4": "Level 4",
    "LEVEL_5": "Level 5"
  },
  "timeHorizon": {
    "VERY_SHORT_TERM": "Very Short Term",
    "SHORT_TERM": "Short Term",
    "MID_TERM": "Mid Term",
    "LONG_TERM": "Long Term",
    "VERY_LONG_TERM": "Very Long Term"
  },
  "household": {
    "create": "Create New Household",
    "createSubmit": "Create household",
    "join": "Join Existing Household",
    "joinSubmit": "Join household",
    "name": "Household Name",
    "relationshipToPrimaryContact": "Relationship to primary contact",
    "permissions": "Permissions",
    "feeGrid": "Fee Grid",
    "billingSchedule": "Billing Schedule"
  },
  "listTileStates": {
    "ENABLED": "Enabled",
    "DISABLED": "Disabled"
  },
  "goals": {
    "goal": "Goal",
    "type": "Goal Type",
    "start": "Start",
    "newGoalPrefix": "New Goal",
    "addGoal": "Add Goal",
    "createGoals_one": "Create {{count}} goal",
    "createGoals_other": "Create {{count}} goals",
    "scopeLabel": "Is this an individual or household goal?",
    "scopes": {
      "INDIVIDUAL": "Individual",
      "HOUSEHOLD": "Household"
    },
    "selectHousehold": "Select Household",
    "existingGoals": "Existing goals",
    "draftGoals": "Draft goals",
    "riskQuestion1": "How much risk are you willing to take with this goal?",
    "riskQuestion1Responses": {
      "LEVEL_1": "I'm not willing to lose anything.",
      "LEVEL_3": "I'm willing to endure some short term losses for moderate return potential.",
      "LEVEL_5": "I'm willing to endure larger short term losses for the highest return potential."
    },
    "applyPortfolioAtGoal": "Apply portfolio at goal",
    "portfolioTheme": "Portfolio Theme",
    "portfolioModel": "Select Model",
    "taxOptimized": "Tax Optimized",
    "taxOptimizedInfo": "A tax optimized portfolio and/or goal refers to the application of the Tax-Loss Harvesting (TLH) strategy. This involves selling of securities that have fallen below their purchase price to generate realized capital losses so they can be used to lower taxes on investment profits by offsetting realized capital gains.",
    "suitability": {
      "info": "Use the suitability scores below to help select the optimal risk level for the portfolio.",
      "goalSuitabilityScore": "Goal Suitability Score",
      "individualSuitabilityScore": "{{name}}'s Suitability Score"
    },
    "accountLinking": {
      "title": "Link goal to account(s)",
      "info": "This generates a sub-account to set your portfolio theme and product. You can choose to do this step later.",
      "inputLabel": "Account(s)"
    },
    "details": {
      "type": "Goal Type",
      "name": "Goal Name",
      "scope": "Goal Scope",
      "timeHorizon": "Time Horizon",
      "targetAmount": "Target Amount",
      "riskTolerance": "Risk Tolerance",
      "portfolioTheme": "Portfolio Theme",
      "portfolioModel": "Model",
      "taxOptimized": "Tax Optimized",
      "accountsLinked": "Linked Accounts"
    }
  },
  "relatedEntities": {
    "summaryTable": {
      "name": "Name",
      "relation": "Relationship"
    },
    "formTitle": "Add relationship",
    "noRelations": "No relationships",
    "addRelation": "Add relationship",
    "newRelatedEntitySuccess": "New relationship added"
  },
  "subAccounts": {
    "summaryTable": {
      "goal": "Goal",
      "account": "Account",
      "product": "Portfolio theme/product",
      "noSubAccounts": "No sub-accounts",
      "productNotSet": "Not set"
    },
    "suitability": {
      "title": "Suitability score",
      "info": "Use the suitability scores to help select the appropriate risk level for this sub-account."
    },
    "formTitle": "{{goalName}} Goal and {{accountName}} Account",
    "requireIPS": "Require Investor Policy Statement",
    "allowFractionalShares": "Allow fractional shares",
    "allowClientDeposits": "Allow client deposits",
    "linkSubAccount": "Link sub-account",
    "subAccountLiquidated": "Sub-account liquidated",
    "warningModal": {
      "title": "Portfolio for {{numSubAccounts}} sub-account{{pluralSuffix}} missing",
      "body": "You forgot to set the portfolio theme and product for {{numSubAccounts}} sub-account{{pluralSuffix}}.",
      "cancelButtonLabel": "Cancel",
      "confirmButtonLabel": "Continue anyway",
      "returnButtonLabel": "Continue editing"
    }
  },
  "createAccountButtonTitle": "Create ({{number}}) account",
  "createTransferButtonTitle": "Initiate ({{number}}) transfer",
  "createTransfersButtonTitle": "Initiate ({{number}}) transfers",
  "start": "Start",
  "accountType": "Account Type",
  "accountReviewPanel": {
    "tfsa": "TFSA",
    "cash": "Cash",
    "rrsp": "RRSP",
    "respSingle": "RESP - Single",
    "jointRespSingle": "Joint RESP - Single",
    "jointRespFamily": "Joint RESP - Family",
    "jointCash": "Joint Cash",
    "respFamily": "RESP - Family",
    "respAdult": "RESP - Adult",
    "corporateCash": "Corporate Cash",
    "successor": "Successor:",
    "affiliate": "Affiliate:",
    "legalGuardian": "Legal Guardian:",
    "careGiver": "Caregiver:",
    "beneficiary": "Beneficiary:",
    "tableItems": {
      "name": "NAME",
      "relationship": "RELATIONSHIP",
      "allocation": "ALLOCATION"
    },
    "basicCanadaEducationSavingsGrant": "Basic Canada Education Savings Grant",
    "additionalCESG": "Additional CESG",
    "canadaLearningBond": "Canada Learning Bond"
  },
  "goalLinking": {
    "title": "Link account to goals(s)",
    "info": "This generates a sub-account to set your portfolio theme and product. You can choose to do this step later.",
    "inputLabel": "Goal(s)",
    "goalsLinked": "Linked Goals"
  },
  "baseAccountCreation": {
    "addAccount": "Add account",
    "addAffiliate": "Add affiliate",
    "affiliationTable": {
      "nameHeader": "Name",
      "relationHeader": "Relationship",
      "typeHeader": "Type",
      "allocationHeader": "Allocation",
      "requiredInfoHeader": "Incomplete Fields"
    },
    "incompleteAffiliationWarning": {
      "title": "Account creation incomplete",
      "bodyText": "One or more affiliations require more information before they can be connected to accounts. Provide the necessary information before retrying."
    }
  },
  "corporateCashAccountReivew": {
    "corporationName": "Corporation Name",
    "affiliates": "Affiliates"
  },
  "corporateCashAccountCreation": {
    "title": "Corporate Cash - {{entityName}}",
    "authorizedIndividual": {
      "title": "Add the authorized individual(s)",
      "inputLabel": "Authorized Individual Name"
    },
    "thirdParty": {
      "title": "Add the third party",
      "inputLabel": "Third Party Name"
    },
    "trustee": {
      "title": "Add the trustee(s)",
      "inputLabel": "Trustee Name"
    },
    "settlor": {
      "title": "Add the settlor(s)",
      "inputLabel": "Settlor Name"
    },
    "protector": {
      "title": "Add the protector(s)",
      "inputLabel": "Protector Name"
    },
    "beneficialOwner": {
      "title": "Add the beneficial owner(s)",
      "inputLabel": "Beneficial Owner Name"
    },
    "incompleteAffiliationError": "Error while adding incomplete entities as affiliations"
  },
  "tfsaAccountCreation": {
    "title": "Tax Free Saving Account",
    "subtitle": "Do you want to add a successor or beneficiary?",
    "addASuccessor": "Add a Successor",
    "successorName": "Successor Name",
    "relationshipToAccountHolder": "Relationship to account holder",
    "addBeneficiaries": "Add Beneficiaries",
    "beneficiaryName": "Beneficiary Name",
    "addAccount": "Add account",
    "allocation": "Allocation"
  },
  "fhsaAccountCreation": {
    "title": "First Home Savings Account",
    "subtitle": "Do you want to add a successor or beneficiary?",
    "addASuccessor": "Add a Successor",
    "successorName": "Successor Name",
    "relationshipToAccountHolder": "Relationship to account holder",
    "addBeneficiaries": "Add Beneficiaries",
    "beneficiaryName": "Beneficiary Name",
    "addAccount": "Add account",
    "allocation": "Allocation"
  },
  "rrspAccountCreation": {
    "title": "Registered Retirement Saving Plan",
    "relationshipToAccountHolder": "Relationship to account holder",
    "addABeneficiary": "Add a beneficiary",
    "beneficiaryName": "Beneficiary Name",
    "addAccount": "Add account",
    "allocation": "Allocation"
  },
  "relationship": "Relationship",
  "jointAccountHolder": {
    "label": "Account co-owner",
    "subLabel": "Joint accounts must have an account co-owner"
  },
  "jointCashCreation": {
    "title": "Joint Cash",
    "name": "Name",
    "addAccount": "Add account"
  },
  "createAccount": {
    "repCodeLabel": "Rep Code",
    "repCodeRequired": "Please select a rep code",
    "repCodePlaceholder": "Select a rep code",
    "repCodeHelpText": "Accounts will be opened under this rep code. Select one to continue.",
    "repCodeOnlyOne": "This is your only assigned rep code.",
    "repCodeNoneAssigned": "You have no active rep codes assigned. Contact your administrator.",
    "repCodeNoAccess": "You need rep code access to open an account. Contact your administrator."
  },
  "respAccountCreation": {
    "respSingleTitle": "Registered Education Savings Plan - Single",
    "jointRespSingleTitle": "Joint Registered Education Savings Plan - Single",
    "jointRespFamilyTitle": "Joint Registered Education Savings Plan - Family",
    "respAdultTitle": "Registered Education Savings Plan - Adult",
    "respFamilyTitle": "Registered Education Savings Plan - Family",
    "subtitle": "Do you want to apply for any of the following government grants?",
    "basicCanadaEducationSavingsGrant": "Basic Canada Education Savings Grant",
    "additionalCESG": "Additional CESG",
    "canadaLearningBond": "Canada Learning Bond",
    "transferredFromAnotherInstitution": "Transferred from another institution",
    "transferDialogTitle": "Confirm your RESP account",
    "transferDialogAccountTypeLabel": "Account type",
    "createNewAccount": "Create New Account",
    "addAnAffiliate": "Add an Affiliate",
    "respAccountsMustHaveAtLeastOneAffiliate": "RESP accounts must have at least 1 affiliate",
    "name": "Name",
    "affiliationType": "Affiliation type",
    "relationshipToAccountHolder": "Relationship to account holder",
    "allocation": "Allocation",
    "isLegalGuardian": "Is the account holder the legal guardian of the beneficiary",
    "isCareGiver": "Is the account holder the caregiver of the beneficiary",
    "linkGoalTitle": "Link account to a goal",
    "linkGoalSubtitle": "This generates a sub-account to set your portfolio theme and product. You can choose to do this step later.",
    "goal": "Goal",
    "addAccount": "Add account",
    "gender": "Gender",
    "respAgeRestrictionError": "Can't open an RESP Adult account due to age restriction",
    "updateBeneficiaryDobRequired": "This RESP account is no longer marked as transferred from another institution, so its beneficiaries must be under 21. Please update the beneficiary's date of birth on the next step before adding or changing any affiliate."
  },
  "customFieldValues": {
    "boolean": {
      "true": "Yes",
      "false": "No"
    }
  },
  "reviewAccount": {
    "type": "Type",
    "govGrants": "Government Grants",
    "affiliates": "Affiliates",
    "accountType": "Account Type",
    "custodian": "Custodian",
    "otherAffiliates": "Other Affiliates",
    "repCode": "Rep Code",
    "linkedGoals": "Linked Goals",
    "deleteAccountConfirmation": {
      "title": "Delete {{accountDisplayTitle}} {{accountId}}",
      "bodyText": "Are you sure you want to permanently delete {{accountDisplayTitle}} ending in {{accountId}}? This action cannot be undone."
    },
    "noWorkflowErrorMessage": "No workflow was configured for editing account"
  },
  "reviewGoal": {
    "name": "Goal Name",
    "timeHorizon": "Time Horizon",
    "riskQuestion": "Risk Level",
    "accounts": "Accounts",
    "portfolio": "Portfolio",
    "goalCard": {
      "type": "Type",
      "time": "Time",
      "target": "Target"
    }
  },
  "sourceOfTransfer": {
    "bankAccount": "Bank Account - EFT",
    "externalTransferIn": "External Transfer In",
    "transferToSubAccount": "Transfer to Other Portfolio"
  },
  "externalTransferCreation": {
    "title": "New External Transfer In"
  },
  "transferMethod": "Transfer Method",
  "transferMethodOptions": {
    "ALL_IN_CASH": "All cash",
    "PARTIAL_CASH": "Partial Cash",
    "ALL_IN_KIND": "All in kind"
  },
  "transferTypeOptions": {
    "WITHDRAW": "Withdraw",
    "DEPOSIT": "Deposit"
  },
  "addAnotherTransfer": "Add another transfer",
  "externalFinancialInstitution": "External Financial Institution",
  "externalAccount": "External Account #",
  "amountToTransfer": "Amount to transfer",
  "addTransfer": "Add transfer",
  "inboundAccount": "Inbound Account",
  "externalTransferReviewPanel": {
    "title": "External Transfer In - {{amount}} to {{accountType}}",
    "institution": "Institution:",
    "account": "Account:",
    "transferMethod": "Transfer Method:"
  },
  "bankAccountTransferCreation": {
    "title": "New Bank Account Transfer In",
    "institutionNumber": "Institution #",
    "transitNumber": "Transit #",
    "accountNumber": "Account #",
    "amountToTransfer": "Amount to transfer",
    "makeRecurring": "Make Recurring",
    "enterAValidDate": "Please enter a valid date",
    "transferDelayError": "Please choose a valid business day on or after {{date}}"
  },
  "bankAccountTransferReviewPanel": {
    "title": "Bank Account Transfer - {{amount}} to {{accountType}}",
    "type": "Type:",
    "deposit": "Deposit",
    "account": "Account:",
    "bankAccount": "Bank Account:",
    "institutionNumber": "Institution #:",
    "accountNumber": "Account #:",
    "transitNumber": "Transit #:",
    "recurring": "Recurring:",
    "frequency": "Frequency:",
    "startDate": "Start Date:"
  },
  "workflowCancelModal": {
    "title": "Are you sure you want to cancel this workflow?",
    "bodyText": "This action cannot be undone.",
    "cleanupError": "Your workflow was cancelled, however some of your data could not be removed / cancelled. Please review and contact support if necessary."
  },
  "createAccountForGoal": {
    "createAccountError": "Could not create account. Please try again later or contact support.",
    "createSubAccountError": "Could not create sub-account. Please try again later or contact support.",
    "duplicateSubAccountWarning": "A new sub-account was created. You may have a duplicate sub-account that can be safely deleted.",
    "numAccountsBadge": "{{numAccounts}} account(s)",
    "confirmDialog": {
      "createNewAccount": {
        "title": "Create new account",
        "body": "A(n) {{accountType}} account(s) already exists. This action will create another separate {{accountType}} account."
      },
      "createNewSubAccount": {
        "title": "Create sub-account",
        "body": "A(n) {{accountType}} account(s) already exists. This action will add a sub-account, allowing you to apply different investment strategies within a single account."
      },
      "dontShowAgain": "Don't show this message again"
    },
    "accountCreationMethodChoice": {
      "title": "Account type exists",
      "confirmButtonLabel": "Continue",
      "body": "{{numAccounts}} {{accountType}} account(s) already exist and are linked to this goal. Would you like to create a new {{accountType}} account, or add a sub-account within the existing account?",
      "bodyNoNewAccount": "{{numAccounts}} {{accountType}} account(s) exist that are linked to this goal. Please choose which account would you like to add a sub-account within?",
      "newAccount": "Create new {{accountType}} account",
      "newSubAccount": "Add sub-account within {{accountName}} {{accountId}}"
    }
  },
  "createGoal": {
    "numGoalsBadge": "{{numGoals}} goal(s)",
    "goalCreationMethodChoice": {
      "title": "Goal type exists",
      "confirmButtonLabel": "Continue",
      "body": "{{numGoals}} {{goalType}} goal(s) already exist. Would you like to create a new {{goalType}} goal, or reuse an existing one?",
      "bodyNoNewGoal": "{{numGoals}} {{goalType}} goal(s) exist. Please choose which goal you would like to use.",
      "existingGoal": "Link account to {{goalName}} ({{marketValue}})",
      "newGoal": "Create new {{goalType}} goal"
    },
    "confirmDialog": {
      "existingGoalConfirmation": {
        "title": "Link to existing goal",
        "bodyText": "A(n) {{goalType}} goal(s) already exists. This action will continue with using the existing {{goalType}} goal."
      },
      "newGoalConfirmation": {
        "title": "Create new goal",
        "bodyText": "A(n) {{goalType}} goal(s) already exists. This action will create another separate {{goalType}} goal."
      }
    }
  },
  "depositReview": {
    "fromBankAccount": "From Bank Account",
    "toBankAccount": "To Bank Account",
    "fromSubAccount": "From Portfolio",
    "toSubAccount": "To",
    "depositDisplayTitle": "{{amount}} to {{account}}",
    "unknownDepositType": "Unknown",
    "toHolding": "Holding",
    "amount": "Amount",
    "reason": "Reason",
    "createDeposit": "Create Deposit",
    "continue": "Continue",
    "updateDeposit": "Update Deposit",
    "createWithdraw": "Create Withdrawal",
    "addAnotherDeposit": "Add another deposit",
    "updateWithdraw": "Update Withdrawal",
    "success": "Deposit created successfully",
    "failure": "Error creating deposit",
    "deny": "Deposit rejected",
    "withdrawSuccess": "Withdraw created successfully",
    "amountExceeds": "This will be a full withdrawal where all your funds will be transferred to your chosen portfolio.",
    "amountExceedsWithdraw": "This will be a full withdrawal where all your funds will be withdrawn.",
    "fullTransfer": "Full Transfer",
    "fullTransferWithCurrency": "Full {{currency}} Transfer",
    "ALL_IN_CASH": "Full Cash Transfer",
    "estimatedAmountLabel": "Estimated Amount",
    "PARTIAL_CASH": "Partial Cash Transfer",
    "ALL_IN_KIND": "All In-Kind Transfer",
    "financialInstitution": "Financial Institution",
    "accountNumber": "Account Number",
    "accountType": "Account Type",
    "transferType": "Transfer Type",
    "schedule": "Schedule",
    "startsOn": "Starts On",
    "scheduledFor": "Scheduled For",
    "allInCashMessage": "All assets in your source account will be sold and transferred as cash.",
    "partialCashMessage": "Enter the cash amount you wish to transfer. Any remaining assets will stay in your source account.",
    "allInKindMessage": "All assets will be transferred directly, without being sold (in their current form).",
    "federalTaxWithheld": "Federal taxes withheld",
    "stateTaxWithheld": "State taxes withheld",
    "grossAmount": "Gross amount",
    "error": "Could not create your transfer.",
    "couldNotCompleteAllDeposits": "One or more transfers could not be completed, please edit or remove unsuccessful transfers to continue.",
    "createTransferError": "Could not create your transfer. {{ message }}",
    "multiDepositDisabledError": "Multi deposit must be disabled for custodian deposit transfers.",
    "deleteDepositConfirmation": {
      "title": "Remove deposit of {{depositDisplayTitle}}",
      "bodyText": "Are you sure you want to remove the deposit of {{depositDisplayTitle}}? This action cannot be undone."
    },
    "noWorkflowErrorMessage": "No workflow was configured for editing deposit",
    "depositNotFoundError": "Deposit not found",
    "noDeposits": "No deposits to review"
  },
  "withdrawReview": {
    "frequency": "Frequency",
    "startsOn": "Starts On",
    "startDate": "Start Date"
  },
  "personalInformation": {
    "underAgeOfMajorityMessage": "Client must be at least {{MINUMUM_AGE}} years old.",
    "futureDateMessage": "Date cannot be in the future"
  },
  "residencyInformation": {
    "foreignTaxInformation": {
      "error": "Country and Tax Identification Number required.",
      "missingCountry": "Tax Identification Number required for {{country}}"
    },
    "taxIdType": "Tax Identification Type",
    "allowITIN": "Allow ITIN for individual clients",
    "allowITINni": "Allow ITIN for non-individual clients",
    "taxIdOnlyApplicableIn": "This Tax ID input is only applicable in Canada or U.S.; see settings - organization - localization.",
    "taxIdExplanationIndividuals1": "Individual clients will be required to input {{type}}",
    "taxIdExplanationIndividuals2": "Individual clients will be required to input either {{type1}} or {{type2}}",
    "taxIdExplanationNonIndividuals": "Non-individual clients will be required to input {{type}}",
    "taxIdExplanationNonIndividuals2": "Non-individual clients will be required to input {{type1}} or {{type2}}",
    "taxIdExplanationNonIndividuals3": "Non-individual clients will be required to input {{type1}}, {{type2}} or {{type3}}",
    "customTaxIdLabelsEnable": "Custom Labels",
    "customTaxIdLabelfor": "{{type}} Field Label"
  },
  "subStepOptions": {
    "optionTypes": {
      "BASIC_OR_SELECT_FIELD": {
        "isSelectLabel": "Use selections",
        "isDefaultSelectLabel": "Use OneVest list",
        "valueColLabel": "Mapped to value"
      },
      "ADDITIONAL_INFO_FIELD": {
        "checkboxLabel": "Additional Information"
      },
      "DEFAULT_VALUE_FIELD": {
        "checkboxLabel": "Default Value"
      },
      "DISCLAIMER_INFO": {
        "checkboxLabel": "Disclaimer"
      },
      "CUSTOM_LABELS_FIELD": {
        "checkboxLabel": "Custom Label",
        "mainSwitch": "Main Switch",
        "goalLabel": "Goal",
        "priceDateLabel": "Price date",
        "currencyLabel": "Currency",
        "unitPriceLabel": "Unit price",
        "tenPercentAmountLabel": "10% free dollar amount",
        "backEndFeePercentageLabel": "Back end fee percentage",
        "marketValueLabel": "Market Value",
        "grossRedemptionLabel": "Gross redemption",
        "backEndRedemptionFeeLabel": "Back end redemption fee",
        "grossProceedsLabel": "Gross proceeds",
        "withholdingTaxLabel": "Withholding tax",
        "netAmountLabel": "Net Amount"
      }
    },
    "visibility": {
      "label": "This workflow step is not visible to clients"
    }
  },
  "updateAccount": {
    "jurisdiction": "Jurisdiction",
    "sourceOfFunds": "Source of funds",
    "sourceOfFundsOptions": {
      "SELF": "Self",
      "SPOUSE": "Spouse",
      "USA_EMPLOYMENT_WAGES": " Employment Wages",
      "USA_INHERITANCE_TRUST": " Inheritance / Trust",
      "USA_LOTTERY_GAMING": "Lottery / Gaming",
      "USA_RETIREMENT_FUNDS": "Retirement Funds",
      "USA_INVESTMENTS": "Investments",
      "USA_SPOUSAL_PARENTAL_SUPPORT": "Spousal / Parental Support",
      "USA_GIFT": "Gift",
      "USA_SAVINGS": "Savings",
      "USA_UNEMPLOYMENT_DISABILITY": " Unemployment / Disability",
      "USA_LEGAL_SETTLEMENT": "Legal Settlement",
      "USA_OTHER": "Other"
    }
  },
  "subAccountTransferCreation": {
    "title": "New Transfer to Existing Portfolio",
    "from": "From",
    "to": "To"
  },
  "subAccountTransferReviewPanel": {
    "title": "Transfer to Existing Portfolio",
    "fromPortfolio": "From Portfolio",
    "toPortfolio": "To Portfolio",
    "amount": "Amount"
  },
  "idVerificationSkipDialog": {
    "title": "Are you sure ?",
    "content1": "You are choosing to skip the ID verification process, which means deposits will not be able to be made until this is completed. To complete your ID check and start investing, please contact our",
    "content2": " support team,",
    "content3": " who will help you verify your identity.",
    "cancel": "Cancel",
    "continue": "Continue"
  },
  "value": "Value",
  "cancelWorkflow": "Cancel Workflow",
  "states": {
    "ACTIVE": "Active",
    "CANCELED": "Canceled",
    "COMPLETED": "Completed"
  },
  "depositTypeOptions": {
    "EFT": "EFT",
    "INTERNAL_TRANSFER": "Internal Transfer",
    "EXTERNAL_TRANSFER": "External Transfer"
  },
  "noDepositTypeSelected": "No deposit type selected. Please select a deposit type.",
  "noDepositTypeSelectedWarning": "No deposit type was selected. No deposit will be created.",
  "subStepTypes": {
    "ACCOUNTS": "Accounts",
    "ACTION_ACTIVATE_ALL_SUB_ACCOUNTS": "Activate All Sub-Accounts",
    "ACTION_INTEGRATION": "Action Create Integration Form Agreement",
    "ACTION_NOTIFY": "Action Notify",
    "ACTION_UPDATE_USER": "Action Update User",
    "ACTION_UPDATE_ACCOUNT": "Action Update Account",
    "APPROVAL": "Approval",
    "ASSIGN_PORTFOLIO_TO_SUB_ACCOUNT": "Assign Portfolio to Sub-Account",
    "ARCHIVE_OBJECTS": "Archive Objects",
    "BANK_ACCOUNT_INFORMATION": "Bank Account Information",
    "CREATE_ACCOUNT_FOR_GOAL": "Create Account for Goal",
    "CREATE_ACCOUNT": "Create Account",
    "CREATE_GOAL": "Create Goal",
    "CREATE_ACCOUNT_GROUP": "Create Account Group",
    "DEPOSIT_FORM": "Deposit Form",
    "MULTI_PORTFOLIO_DEPOSIT": "Multi Portfolio Deposit",
    "DEPOSIT_REVIEW": "Deposit Review",
    "DEPOSIT_TYPE": "Deposit Type",
    "DOCUMENTS": "Documents",
    "EDIT_ACCOUNT": "Edit Account",
    "EDIT_GOAL": "Edit Goal",
    "EMPLOYMENT_INFORMATION": "Employment Information",
    "FINANCIAL_PROJECTIONS": "Financial Projections",
    "GOALS": "Goals",
    "GOAL_RISK_QUESTION_1": "Goal Risk Question",
    "HOUSEHOLD": "Household",
    "INITIALIZE_HOUSEHOLD_MODEL_PORTFOLIO": "Initialize Household Model Portfolio",
    "SELECT_HOUSEHOLD_PARENT_MODEL_PORTFOLIO": "Select Household Parent Model Portfolio",
    "SELECT_MODEL_PORTFOLIO_EDIT_TYPE": "Select Model Portfolio Edit Type",
    "DETACH_MODEL_PORTFOLIO": "Detach Model Portfolio",
    "EDIT_HOUSEHOLD_MODEL_PORTFOLIO_IPS": "Edit Household Model Portfolio IPS",
    "ADD_MODEL_PORTFOLIO_SECURITY_ALLOCATIONS": "Edit Security Allocations",
    "REVIEW_ALLOCATIONS": "Review Allocations",
    "REVIEW_IPS_SUMMARY": "Review IPS Summary",
    "EDIT_ACCOUNT_ALLOCATIONS": "Edit Account Allocations",
    "REVIEW_ACCOUNT_ALLOCATIONS": "Review Account Allocations",
    "APPLY_ACCOUNT_ALLOCATIONS": "Apply Account Allocations",
    "ACTION_TRANSITION_MODEL_CHANGE_PROPOSAL": "Action Transition Model Change Proposal",
    "ID_VERIFICATION": "ID Verification",
    "INCOME_ASSETS_AND_DEBTS": "Income, Assets, and Debts",
    "INVESTMENT_KNOWLEDGE": "Investment Knowledge",
    "NET_WORTH": "Net Worth",
    "NON_INDIVIDUAL_INFORMATION": "Non-Individual Information",
    "NON_INDIVIDUAL_SETUP": "Non-Individual Setup",
    "PERSONAL_INFORMATION": "Personal Information",
    "PERSONS_OF_INTEREST": "Persons of Interest",
    "PROJECTIONS": "Projections",
    "RELATED_ENTITIES": "Related Entities",
    "RELATIONSHIP_INFORMATION": "Relationship Information",
    "RESIDENCY_INFORMATION": "Residency Information",
    "REVIEW": "Review",
    "REVIEW_ACCOUNT": "Review Account",
    "REVIEW_BANK_ACCOUNT_INFORMATION": "Review Bank Account Information",
    "REVIEW_GOAL": "Review Goal",
    "REVIEW_PORTFOLIO_CHANGES": "Review Portfolio Changes",
    "RISK_PROFILE": "Risk Profile",
    "RISK_QUESTION_1": "Risk Question 1",
    "RISK_QUESTION_2": "Risk Question 2",
    "SUB_ACCOUNTS": "Sub-Accounts",
    "TRANSFERS": "Transfers",
    "COLLECT_SIGNERS": "Collect Signers",
    "ACTION_ADD_FORM_DEFINITION": "Action Add Form Definition - Beta",
    "PREPARE_FORM_COMPLETIONS": "Prepare Form Completions - Beta",
    "SIGN_FORM_COMPLETIONS": "Sign Form Completions - Beta",
    "MANAGE_FORM_COMPLETIONS": "Manage Form Completions - Beta",
    "MANAGE_SIGNERS": "Manage Signers - Beta",
    "CREATE_INTEGRATION_FORM_PACK": "Create Integration Form Pack - Beta",
    "SEND_INTEGRATION_FORM_PACK": "Send Integration Form Pack - Beta",
    "SYNCHRONOUS_INTEGRATION": "Synchronous Integration",
    "REDIRECT_HANDLER": "Redirect Handler",
    "WITHDRAW_FORM": "Withdraw Form",
    "WITHDRAW_REVIEW": "Withdraw Review",
    "CALCULATOR": "Calculator",
    "USER_VERIFICATION": "User Verification",
    "ACTION_AFFILIATE_INVITATION": "Action Affiliate Invitation",
    "WORKFLOW_REVIEW": "Workflow Review"
  },
  "householdInitializeShells": {
    "noDraftSelected": "No parent model has been selected yet. Go back to select one before continuing.",
    "initializeButton": "Initialize",
    "selectParentModelError": "Unable to load the selected model portfolio. Please try again.",
    "commitError": "Unable to create and attach the model portfolio. Please try again.",
    "commitProposalPending": "This household has a proposed model change waiting to be signed. Complete or discard it before changing the model portfolio.",
    "commitWarning": "The model portfolio was created with warnings.",
    "commitMissingData": "Missing required details to initialize. Go back and reselect the parent model.",
    "commitBlockedAllocations": "The allocations below need adjusting before this household can be initialized.",
    "modelName": {
      "label": "Model name",
      "helpText": "The name for this household's own copy of the model."
    },
    "summary": {
      "title": "Summary",
      "parentModel": "Parent model",
      "tradingProcess": "Trading process"
    }
  },
  "householdModelPortfolioIps": {
    "saveError": "Unable to save the investment policy statement. Please try again.",
    "applyWarning": "The investment policy statement was saved with warnings.",
    "applyMissingData": "Missing the details needed to update the model portfolio. Close this workflow and start it again from the household.",
    "loadError": "Unable to load the household's model portfolio. Please try again.",
    "missingModel": "This household has no model portfolio to edit. Close this workflow and attach one first.",
    "missingHousehold": "Missing the household to edit. Close this workflow and start it again from the household.",
    "summaryEmpty": "No investment policy details have been captured for this model portfolio.",
    "current": "Current",
    "proposed": "Proposed"
  },
  "discardModelChangeProposal": {
    "title": "Discard this proposed change?",
    "body": "This workflow has a proposed model change open against the household. Discarding it cancels the proposal, including any signature it is waiting on, and closes this workflow, so the household can be changed again from the start. Keeping it leaves the proposal open for someone to sign and the workflow here to be carried on with.",
    "discard": "Discard change",
    "keep": "Keep it"
  },
  "householdModelPortfolioAllocations": {
    "security": "Security",
    "assetClass": "Asset class",
    "current": "Current",
    "currentPercent": "Current (%)",
    "currentValue": "Current ($)",
    "proposed": "Proposed",
    "proposedPercent": "Proposed (%)",
    "proposedValue": "Proposed ($)",
    "portfolioPercentSubheader": "Portfolio %",
    "percentageViewPortfolio": "Portfolio %",
    "percentageViewAssetClass": "Within class %",
    "portfolioAllocationSummary": "Portfolio allocation",
    "change": "Change",
    "total": "Total",
    "currentBalance": "Total Market Value",
    "newHolding": "New",
    "removedHolding": "Removed",
    "changeCount_one": "{{count}} of {{total}} holdings changed.",
    "changeCount_other": "{{count}} of {{total}} holdings changed.",
    "noChanges": "None of the holdings changed.",
    "onlyChanges": "Only show changes",
    "noChangesInView": "No holdings changed in this view.",
    "empty": "This model portfolio has no holdings to review.",
    "nothingProposed": "The proposed holdings are empty. Go back to the allocations step and add at least one before continuing.",
    "doesNotAddUp": "The proposed holdings do not add up to 100%. Go back to the allocations step and adjust them before continuing.",
    "groupsDoNotAddUp": "The holdings in each asset class must add up to 100%, and every holding must belong to one. Go back to the allocations step and adjust them before continuing.",
    "groupWeightsDoNotAddUp": "The asset class weights must add up to 100% before this model portfolio can be changed. Go back to the allocations step and set them.",
    "duplicateHolding": "The same security is held twice in the proposed holdings. Go back to the allocations step and remove the duplicate before continuing.",
    "initializeBlocked": {
      "empty": "This model portfolio has no holdings. Add at least one before initializing.",
      "incompleteHolding": "A row is missing a security. Select one for each row before initializing.",
      "duplicateHolding": "The same security is held twice. Remove the duplicate before initializing.",
      "doesNotAddUp": "The holdings do not add up to 100%. Adjust them before initializing.",
      "groupsDoNotAddUp": "The holdings in each asset class must add up to 100%, and every holding must belong to one. Adjust them before initializing.",
      "groupWeightsDoNotAddUp": "The asset class weights must add up to 100%. Set them before initializing.",
      "duplicateTaxRank": "Two holdings have the same tax rank. Give each one its own rank before initializing.",
      "taxRankGaps": "Tax ranks must start at 1 and run in order with no gaps. Adjust them before initializing."
    },
    "missingCurrent": "This workflow no longer knows what the household holds today, which a model change has to be signed against. Close this workflow and start it again from the household.",
    "saveError": "Unable to save the proposed model change. Please try again.",
    "submitError": "Unable to send the model change for signature. Please try again.",
    "notEditable": "This household already has a model change waiting to be signed. Complete or cancel it before proposing another.",
    "missingData": "Missing the details needed to propose a model change. Close this workflow and start it again from the household."
  },
  "householdDetach": {
    "detachButton": "Detach",
    "detachError": "Unable to detach the model portfolio. Please try again.",
    "archiveWarning": "The model portfolio was detached, but the household's copy of it could not be archived. It will be cleaned up the next time a model portfolio is attached.",
    "archiveProposalPending": "The model portfolio was detached, but the household's copy of it could not be archived while a proposed model change is waiting to be signed. Complete or discard that change to clean it up.",
    "missingHousehold": "Missing the household to detach from. Close this workflow and start it again from the household."
  },
  "selectModelPortfolioEditType": {
    "customizedSingleAccountTooltip": "Customized allocations need more than one account in the household. To change this household's allocations, edit the household allocations instead."
  },
  "formArchived": "Form archived successfully",
  "formReuploaded": "Form reuploaded successfully",
  "formArchiveError": "Error in archiving form",
  "formReuploadError": "Error in reuploading form",
  "formPdfLoadError": "PDF failed to load after max retries",
  "updateBranch": "Update Branch",
  "addCondition": "Add Condition",
  "removeCondition": "Remove Condition",
  "deleteBranch": "Delete Branch",
  "sections": "Sections",
  "unsavedChanges": "Unsaved Changes",
  "editWorkflow": "Edit Workflow",
  "conditionOn": "Condition Based On",
  "client": "Client",
  "contextAccount": "Account in context",
  "contextSubAccount": "Sub-account in context",
  "contextGoal": "Goal in context",
  "contextTransfer": "Transfer in context",
  "contextHousehold": "Household in context",
  "user": "Clients",
  "uploadSignedForm": "Upload Signed Form Below",
  "conditionFieldInfo": "You can pre select any object attribute from the dropdown, otherwise type any custom field key",
  "settings": "Settings",
  "prepareFormCompletions": {
    "title": "Preparing Form Packages",
    "description": "This will prepare all forms required for signing. This may take a few minutes to complete.",
    "householdPrimaryUserNotFound": "Could not find the primary user for this household."
  },
  "createIntegrationFormPack": {
    "title": "Creating Form Pack",
    "description": "This will create the form pack for signing. This may take a few minutes to complete."
  },
  "sendIntegrationFormPack": {
    "title": "Sending Invites for Form Pack",
    "description": "This will send the invites for the form pack to all the signers. This may take a few minutes to complete."
  },
  "signFormCompletions": {
    "resendForSignature": "Resend for signature",
    "resendConfirmTitle": "Resend for signature?",
    "resendConfirmBody": "This will send a new signing notification to unfinished signers. Any signing progress on this package will be kept.",
    "resendSuccess": "Form package resent for signature.",
    "resendError": "Could not resend the form package. Try regenerating forms if the issue persists."
  },
  "settingsModal": {
    "title": "Workflow Settings",
    "saveButton": "Save",
    "displayCloseButton": "Display close button (X) on workflow steps",
    "cancelOnClose": "Upon close (X), cancel the workflow and remove from profile",
    "archiveObjectsOnClose": [
      "Upon cancel, archive the following objects that were created in the workflow (account, goal, sub-account and/or transfer).",
      "This will not apply to editing objects."
    ],
    "applicableRoleProfiles": "Can trigger workflow",
    "applicableRoleProfilesSupport": "By default, all Role Profiles can trigger workflows. Select specific profiles to restrict."
  },
  "manageSigners": {
    "manageSigners": "Manage Signers",
    "description": "Loading the required signers.",
    "useOrgUser": "Use Organization User",
    "firstName": "First Name",
    "lastName": "Last Name",
    "email": "Email",
    "signingOrder": "Signing Order",
    "user": "User",
    "restrictedByRole": "Restricted by role",
    "restrictedToRoles": "Restricted to role(s)",
    "clientSigner": "Client signer",
    "signingDocuments": "Signing:",
    "linkedSigner": "Sent as one signer, order {{order}}"
  },
  "visibility": {
    "label": "This action will only be visible to users with the appropriate permissions"
  },
  "enableCallToActions": "Enable Call to Actions",
  "callToActions": "Call to Actions",
  "action": "Action",
  "buttonVariant": "Button Variant",
  "buttonColor": "Button Color",
  "addAction": "Add Action",
  "primary": "Primary",
  "destructive": "Destructive",
  "filled": "Filled",
  "tonal": "Tonal",
  "outlined": "Outlined",
  "text": "Text",
  "buttonLabel": "Button Label",
  "changeToBasicWorkflow": "Change to Basic Workflow",
  "changeToComplexWorkflow": "Change to Complex Workflow",
  "addNewForm": "Add New Form",
  "downloadAllForms": "Download All Forms",
  "downloadAllFormsFileName": "Zip file name",
  "downloadAllFormsError": "Could not download forms",
  "downloadAllFormsPartialError": "Some forms could not be downloaded",
  "formDefinition": "Form Definition",
  "prepare": "Prepare",
  "regenerateForms": {
    "button": "Regenerate Forms",
    "title": "Regenerate Forms",
    "body": "This will cancel the current signing package. Any pending signatures will be lost and signers will need to sign again. Would you like to continue?",
    "confirm": "Cancel Package & Regenerate",
    "cancel": "Keep Current Forms"
  },
  "fiscalYearForRecurringContributions": "Recurring contributions always apply to the current tax year. The system will automatically update to the new tax year on January 1. To contribute to a prior year (allowed until April 15), use a one-time or future-dated deposit instead.",
  "netWorthDetails": {
    "CASH": "Cash details",
    "EXTERNAL_INVESTMENT_ACCOUNT": "Investments details",
    "REAL_ESTATE": "Real Estate details",
    "VEHICLES": "Vehicles details",
    "VALUABLES": "Valuables details",
    "OTHER_ASSET": "Other assets details",
    "OTHER_LIABILITY": "Other liabilities details",
    "LOANS": "Loans details",
    "MORTGAGE": "Mortgage details",
    "CREDIT_CARD": "Credit Card details",
    "confirmButton": "Confirm",
    "addMoreButton": "Add More"
  },
  "incompleteSignerInfo": "Incomplete information has been entered for a signer.",
  "unableToRedirectForVerification": "Unable to redirect for verification.",
  "exampleData": {
    "assetClasses": {
      "alternativeInvestments": "Alternative Investments",
      "fixedIncome": "Fixed Income",
      "equities": "Equities",
      "realAssets": "Real Assets"
    },
    "testDocument": "Test Document"
  },
  "archiveObjects": {
    "accounts": "Accounts",
    "goals": "Goals",
    "subAccounts": "Sub-Accounts",
    "transfers": "Transfers",
    "scheduledTransfers": "Scheduled Transfers",
    "externalTransfers": "External Transfers",
    "custodianDepositTransfers": "Custodian Deposit Transfers",
    "type": "Type",
    "state": "State",
    "name": "Name",
    "goalName": "Goal",
    "accountType": "Account Type",
    "accountId": "Account ID",
    "amount": "Amount",
    "currency": "Currency",
    "frequency": "Frequency",
    "startDate": "Start Date",
    "institution": "Institution",
    "transferMethod": "Transfer Method",
    "total": "Total: {{count}}",
    "noObjectsToArchive": "There were no objects created during this workflow or they have already been archived, nothing to archive.",
    "archiveObjectsWarning": "The following objects will be archived:",
    "archivingMessage": "Archiving {{objects}} created during this workflow."
  },
  "redirectHandler": {
    "redirecting": "Redirecting to verification...",
    "successTitle": "Transfer verified successfully",
    "successSubtitle": "Your deposit transfer has been verified and is being processed.",
    "failureTitle": "Verification was unsuccessful",
    "failureSubtitle": "The verification could not be completed.",
    "cancelling": "Verification failed, cancelling transfer...",
    "closedTabTitle": "Verification was not completed",
    "closedTabSubtitle": "The verification page was closed before it could be completed.",
    "retry": "Retry Verification",
    "cancel": "Cancel Transfer",
    "close": "Close",
    "cancelSuccess": "Transfer cancelled successfully.",
    "cancelError": "Unable to cancel transfer. Please try again."
  },
  "documentsSubStep": {
    "title": "Sign your documents",
    "subtitle": "Review the documents and sign them"
  },
  "assignPortfolioToSubAccountSubStep": {
    "title": "What theme best fits your investment goal?",
    "subtitle": "Please select your preference. You can change it at any time.",
    "skipHouseholdPortfolioError": "Unable to skip portfolio assignment. Please try again.",
    "missingSubAccountError": "We couldn't find the sub-account to assign a portfolio to. Please go back and try again, or contact support."
  },
  "createAccountForGoalSubStep": {
    "title": "What account would you like to start with?",
    "subtitle": "The account type you select may impact the taxes you pay on your investment returns."
  },
  "unsignedDocumentsWorkflow": {
    "stepName": "Sign Documents"
  },
  "depositWorkflow": {
    "stepName": "Deposit Funds",
    "reviewStepName": "Review & Submit",
    "depositType": {
      "title": "What type of deposit would you like to make?",
      "eft": "Electronic Funds Transfer",
      "internalTransfer": "Existing Portfolio",
      "externalTransfer": "External Account"
    },
    "depositForm": {
      "title": "Deposit Funds",
      "from": "From",
      "to": "To",
      "schedule": "Schedule",
      "starting": "Starting",
      "financialInstitution": "Financial Institution",
      "accountNumber": "Account Number",
      "accountType": "Account Type",
      "transferType": "Transfer Type",
      "contributionYear": "Contribution year",
      "amount": "Amount",
      "manualBankAccountLinking": "Manual Bank Account Linking",
      "allowDocumentUpload": "Allow Document Upload",
      "automatedBankAccountLinking": "Automated Bank Account Linking"
    },
    "depositReview": {
      "title": "Review & Submit",
      "eftDisclaimer": "Expect the amount to be withdrawn from your account within 1 to 2 business days.",
      "internalTransferDisclaimer": "Expect the amount to be deposited into your account within 3 business days.",
      "externalTransferDisclaimer": "You hereby request the transfer of your account and its investments as described above. You understand that you may incur a transfer out fee charged by your relinquishing institution as well other application fees and charges."
    }
  },
  "withdrawWorkflow": {
    "stepName": "Withdraw Funds",
    "reviewStepName": "Review & Submit",
    "withdrawForm": {
      "title": "Withdraw Funds",
      "to": "To",
      "schedule": "Schedule",
      "from": "From",
      "amount": "Amount",
      "reason": "Reason"
    },
    "withdrawReview": {
      "title": "Review & Submit"
    }
  },
  "scheduleWithdrawWorkflow": {
    "stepName": "Withdraw Funds",
    "reviewStepName": "Review & Submit",
    "withdrawForm": {
      "title": "Withdraw Funds",
      "to": "To",
      "schedule": "Schedule",
      "from": "From",
      "amount": "Amount",
      "reason": "Reason"
    },
    "withdrawReview": {
      "title": "Review & Submit"
    }
  },
  "createGoalWorkflow": {
    "stepName": "New Goal",
    "createGoal": {
      "title": "What is your new investment goal?"
    },
    "timeHorizon": {
      "title": "When would you like to withdraw your funds?",
      "subtitle": "Assume you have achieved your goal. What time horizon best fits with when you want to access the majority of your funds."
    },
    "targetAmount": {
      "title": "What's your target amount?",
      "subtitle": "This helps us recommend the right savings targets to meet your goal. An estimate is fine."
    },
    "goalRiskQuestion": {
      "title": "How much risk are you willing to take with this goal?",
      "subtitle": "For this specific goal, how much are you looking to maximize the reward compared to the risk you would like to take.",
      "level1": "I'm not willing to lose anything",
      "level3": "I'm willing to endure some short term losses for a moderate return potential",
      "level5": "I'm willing to endure larger short term losses for the highest return potential"
    },
    "goalExitedSuccess": "Goal creation has been successfully exited",
    "errorClosingGoal": "Error closing goal"
  },
  "createEntityWorkflow": {
    "stepName": "Create entity",
    "typeSelect": {
      "title": "What type of entity would you like to create?",
      "individual": "Individual",
      "nonIndividual": "Non - Individual"
    },
    "nonIndividualTypeSelect": {
      "title": "What type of non-individual entity would you like to create?",
      "publiclyListedEntity": "Publicly Listed Entity",
      "privateCompany": "Private Company",
      "partnership": "Partnership",
      "soleProprietorship": "Sole Proprietorship",
      "trust": "Trust",
      "investmentFund": "Investment Fund",
      "regulatedEntity": "Regulated Entity",
      "other": "Other"
    },
    "entityCreation": {
      "title": "Entity creation",
      "email": "Email",
      "firstName": "First Name",
      "middleName": "Middle Name",
      "lastName": "Last Name",
      "entityName": "Entity Name"
    }
  },
  "createSubAccountWorkflow": {
    "stepName": "New Goal",
    "editAccount": {
      "title": "Input your account information"
    }
  },
  "createSubAccountFromAccountWorkflow": {
    "stepName": "New portfolio",
    "createSubAccount": {
      "title": "What is your investment goal?",
      "subtitle": "Select a goal to link with your portfolio."
    }
  },
  "createModelPortfolioWorkflow": {
    "stepName": "Create model portfolio",
    "choosePortfolioType": {
      "title": "How do you want to create your model?",
      "subtitle": "You can create a model portfolio from scratch or use a pre-existing template.",
      "fromScratchLabel": "Build from scratch",
      "fromScratchDescription": "Add securities from the product shelf and set the target percentage and tax ranking all from within the model builder UI.",
      "fromTemplateLabel": "Create from asset template",
      "fromTemplateDescription": "Use a pre-existing template of different asset allocations and assign the underlying securities in accordance with the template with your strategy."
    },
    "selectTemplate": {
      "label": "Select asset template",
      "description": "Build unique models from preset asset class allocations, allowing for both consistency and flexibility with your strategies.",
      "templateSelectorLabel": "Template Name",
      "assetClassAllocationLabel": "Asset Class Allocation"
    },
    "createTemplate": {
      "label": "Create asset template",
      "description": "Build unique models from preset asset class allocations, allowing for both consistency and flexibility with your strategies.",
      "templateNameLabel": "Template Name",
      "templateDescriptionLabel": "Template Description",
      "assetClassLabel": "Asset Class",
      "targetLabel": "Target",
      "buttonSaveForLater": "Save for later"
    },
    "addDetails": {
      "title": "Add model details",
      "strategyLabel": "Model Strategy",
      "translatedNameLabel": "Model Name",
      "translatedPortfolioDescriptionLabel": "Model Description",
      "translatedInvestmentObjectiveLabel": "Investment Objective",
      "riskProfileNameLabel": "Risk Profile",
      "themeIdLabel": "Model Family",
      "suggestableLabel": "Suggestible",
      "zeroPercentCashLabel": "0% Cash",
      "lowThresholdScoreLabel": "Lowest Threshold Score",
      "suggestedMinScoreLabel": "Minimum Score",
      "suggestedMaxScoreLabel": "Maximum Score",
      "forecastedRateOfReturnLabel": "Forecasted Rate of Return",
      "forecastedStandardDeviationLabel": "Forecasted Standard Deviation",
      "riskReturnLevelLabel": "Risk/Return Level",
      "urlLabel": "Fundamental Details Link",
      "buttonSaveForLater": "Save for later",
      "driftSettingsLabel": "Drift Settings"
    },
    "addSecurities": {
      "title": "Add securities",
      "showSecurityAllocationTableLabel": "Security Allocation Table",
      "securityAllocationChartLabel": "Security Allocation Chart",
      "columnSecurityLabel": "Security",
      "columnAssetClassLabel": "Asset Class",
      "columnTaxRankLabel": "Tax Rank",
      "columnTargetPercentageLabel": "Target %",
      "buttonRemoveSecurity": "Remove",
      "buttonSaveForLater": "Save for later",
      "importFromCsv": "Import from CSV",
      "validateSecuritiesLabel": "Validate Securities",
      "validateSecuritiesTitle": "Incomplete allocation",
      "validateSecuritiesBodyText": "Each model's securities must total 100%. While you can finalize this later, the model cannot be set to Active or assigned to a portfolio until the total is correct.",
      "validateSecuritiesCheckboxLabel": "Utilize remaining allocation into new or existing Cash & Equivalents"
    },
    "addIps": {
      "title": "Add Investment Policy Statement",
      "ipsLabel": "Investment Policy Statement",
      "ipsDescriptionLabel": "Description",
      "ipsObjectiveLabel": "Objective",
      "ipsLiquidityLabel": "Liquidity",
      "disclaimerLabel": "Disclaimer",
      "assetClassesDistributionLabel": "Asset Classes",
      "buttonSaveForLater": "Save for later"
    }
  },
  "createAccountGroupWorkflow": {
    "stepName": "Create Account Group",
    "createAccountGroup": {
      "title": "Create Account Group",
      "subtitle": "Create an account group to organize your accounts"
    }
  },
  "createAssetTemplateWorkflow": {
    "stepName": "Create asset template",
    "createAssetTemplate": {
      "label": "Create asset template",
      "description": "Build unique models from preset asset class allocations, allowing for both consistency and flexibility with your strategies.",
      "templateNameLabel": "Template Name",
      "templateDescriptionLabel": "Template Description",
      "assetClassAllocationLabel": "Asset Class Allocation",
      "assetClassLabel": "Asset Class",
      "targetLabel": "Target",
      "buttonCreate": "Create"
    }
  },
  "calculator": {
    "title": "Redemption calculator",
    "input": {
      "title": "Input"
    },
    "amountLabels": {
      "amountRequired": "Amount required",
      "numberOfShares": "Number of shares"
    },
    "results": {
      "title": "Results",
      "positionDetail": "Current Position",
      "summary": "Redemption Summary",
      "exchangeRate": "Exchange rate: 1 CAD = {{rate}} USD",
      "priceDate": "Price date:",
      "currency": "Base currency:",
      "unitPrice": "Unit price:",
      "tenPercentAmount": "10% free dollar amount:",
      "backEndFeePercentage": "Back end fee percentage:",
      "marketValue": "Market value:",
      "grossRedemption": "Gross redemption:",
      "backEndRedemptionFee": "Back end redemption fee:",
      "grossProceeds": "Gross proceeds:",
      "withholdingTax": "Withholding tax:",
      "netAmount": "Net amount:"
    },
    "redeem": "Redeem",
    "selectFund": "Select fund",
    "amountType": "Amount type",
    "selectAccount": "Select account",
    "fund": "Fund",
    "removeFund": "Remove fund",
    "addFund": "Add fund",
    "calculate": "Calculate",
    "clear": "Clear",
    "download": "Download PDF",
    "pdfPreview": {
      "title": "Download PDF",
      "fileName": "File name",
      "save": "Save PDF",
      "cancel": "Cancel",
      "generateError": "Unable to generate the PDF preview. Please try again.",
      "saveError": "Unable to save the PDF. Please try again."
    },
    "error": "No data can be displayed",
    "errors": {
      "dollarExceed": "Amount exceeds withdrawal value.",
      "sharesExceed": "Amount exceeds quantity held."
    },
    "noSecuritiesToRedeem": "This account has no securities to redeem.",
    "redeemModes": {
      "single": "A single fund",
      "multiple": "Multiple fund",
      "entire": "Entire account"
    },
    "amountTypes": {
      "allShares": "All shares",
      "shares": "Shares/Units",
      "dollarAmount": "Dollars - gross",
      "dollarNetAmount": "Dollar - net",
      "annualFreeAllocation": "Annual free allocation (10% Free)",
      "dscFree": "DSC free (Matured units & 10% Free)"
    }
  },
  "netWorthWorkflow": {
    "stepName": "Add Net Worth",
    "netWorth": {
      "title": "How would you like to add your asset or liability?",
      "subtitle": "This will help us understand your financial situation and provide you with the best possible service.",
      "automaticLinkTitle": "Connect automatically with your account",
      "automaticLinkSubtitle": "Securely link your bank accounts through our provider to instantly sync your financial information.",
      "manualLinkTitle": "Manually input information",
      "manualLinkSubtitle": "Fill in all the required information to manually enter and manage your financial details."
    }
  },
  "editAccountAllocations": {
    "unavailable": "This household's account allocations could not be loaded.",
    "stagingFailed": "The account allocations could not be saved. Please try again."
  },
  "reviewAccountAllocations": {
    "approve": "Approve",
    "unavailable": "This household's account allocations could not be loaded.",
    "changeCount_one": "{{count}} allocation changes.",
    "changeCount_other": "{{count}} allocations change.",
    "noChanges": "No allocations change.",
    "blocked": {
      "MISSING_STAGING": "There are no edited allocations to review. Go back and continue from the editor.",
      "STALE_REPORT": "This household's portfolio was updated after the edit. Go back and edit the allocations again.",
      "MEMBERSHIP_CHANGED": "The accounts in this household changed after the edit ({{accounts}}). {{restart}}",
      "MEMBERSHIP_CHANGED_unnamed": "The accounts in this household changed after the edit. {{restart}}",
      "BASELINE_CHANGED": "This household's allocations changed after the edit, for example on the Portfolio tab. {{restart}}",
      "INVALID_ACCOUNT_TOTALS": "An account's allocations no longer add up to 100%. {{restart}}"
    },
    "restart": {
      "cancel": "Cancel and start a new edit.",
      "close": "Close this workflow and start a new one."
    }
  },
  "applyAccountAllocations": {
    "title": "Apply account allocations",
    "applying": "Applying allocations…",
    "retry": "Retry",
    "startAgain": "Start a new allocation edit to continue.",
    "accountsAdded": "Accounts added",
    "accountsRemoved": "Accounts removed",
    "accountNoLongerInHousehold": "An account no longer in this household",
    "blocked": {
      "MISSING_SNAPSHOT": "There is no signed allocation to apply for this household.",
      "STALE_REPORT": "This household's portfolio was replaced after the allocation was prepared, so the signed allocation can't be applied.",
      "MEMBERSHIP_CHANGED": "This household's accounts changed after the allocation was prepared, so the signed allocation can't be applied.",
      "BASELINE_CHANGED": "This household's allocations were changed after the allocation was prepared, so the signed allocation can't be applied."
    },
    "errors": {
      "NOT_ACCESSIBLE": "You don't have permission to change this household's allocations. Ask an administrator for access, then retry.",
      "NOT_CUSTOMIZED": "This household's portfolio wasn't ready for customized allocations. Retry to apply them again.",
      "WRONG_REPORT_MEMBER": "This household's accounts don't match the signed allocation. Retry to check them again."
    }
  },
  "workflowLaunch": {
    "errors": {
      "missingId": "The workflow could not be started because the owner could not be determined.",
      "unsupported": "This workflow cannot be started for this type of record.",
      "createFailed": "The workflow could not be started for this record. Check that it still exists and that you have access to it."
    }
  }
}
